export const previewAssetUrl = (id) =>
  `${process.env.REACT_APP_API_URL}/v1/assets/origin-asset/${id}`;
